const H1 = ({text,id}) => <h1 id={id}>{text}</h1>

export default H1